import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { checkoutConfirmationPageQueryOptions } from "~/app/api/pageData/checkoutConfirmationPageQuery";
import type { CheckoutConfirmationPageInitialData } from "~/app/api/pageData/checkoutConfirmationPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createOrderConfirmationPage } from "~/features/cart/cart/jspComponents/OrderConfirmationPageComponent";
import { createQuoteConfirmationPage } from "~/features/cart/cart/jspComponents/QuoteConfirmationPageComponent";

function CheckoutConfirmationRoute() {
  const result = useLoaderData({
    from: "/checkout/orderConfirmation/$referenceCode",
  }) as PageInitialData<CheckoutConfirmationPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {result.data.customerInitiatedQuote ? createQuoteConfirmationPage() : createOrderConfirmationPage()}
    </StorefrontShellFrame>
  );
}

export async function loadCheckoutConfirmationPageData(context: { queryClient: QueryClient }, referenceCode: string) {
  const result = await context.queryClient.ensureQueryData(checkoutConfirmationPageQueryOptions(referenceCode));

  return unwrapPageInitialData(result);
}

export const checkoutConfirmationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/checkout/orderConfirmation/$referenceCode",
  loader: async ({ context, params }) => loadCheckoutConfirmationPageData(context, params.referenceCode),
  component: CheckoutConfirmationRoute,
});
